import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import es from './locales/es.json'

const LOCALE_KEY = 'locale'
const DEFAULT_LOCALE = 'es'

function getSavedLocale(): string {
  const saved = localStorage.getItem(LOCALE_KEY)
  return saved === 'en' || saved === 'es' ? saved : DEFAULT_LOCALE
}

export const i18n = createI18n({
  legacy: false,
  locale: getSavedLocale(),
  fallbackLocale: 'en',
  messages: { en, es },
})

export function setLocale(locale: 'en' | 'es'): void {
  ;(i18n.global.locale as { value: string }).value = locale
  localStorage.setItem(LOCALE_KEY, locale)
  document.documentElement.lang = locale
}

export function getLocale(): string {
  return (i18n.global.locale as { value: string }).value
}
